import { Box, CircularProgress } from '@mui/material'

export const MapLoading = () => (
  <Box
    sx={{
      position: 'absolute',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      background: 'rgba(255,255,255,0.4)',
      zIndex: 9999,
      width: '-webkit-fill-available',
      height: '-webkit-fill-available',
    }}
  >
    <CircularProgress />
  </Box>
)
